import React from 'react'
import Trns from 'src/localization/Trns'
import { isUrl } from 'src/utils/string.utils'

export const stringIsEmpty =
  (message?: string) =>
  (val?: string): React.ReactElement | undefined =>
    val === undefined || val?.trim().length === 0 ? (
      <Trns source={message !== undefined ? message : 'Must not be blank'} />
    ) : undefined

export const stringArrayIsEmpty = (
  val?: string[],
): React.ReactElement | undefined =>
  val === undefined || val.length === 0 ? (
    <Trns source={'Must not be blank'} />
  ) : undefined

export const stringHasSpace = (val?: string): React.ReactElement | undefined =>
  val === undefined || val.indexOf(' ') >= 0 ? (
    <Trns source={'Must not have a space'} />
  ) : undefined

export const stringLengthIsBetween =
  (min: number, max: number) =>
  (val?: string): React.ReactElement | undefined => {
    return val !== undefined && (val.length < min || val.length > max) ? (
      <Trns
        source={'Must be between ${min} and ${max} in digits in length'}
        expressions={{
          min: `${min}`,
          max: `${max}`,
        }}
      />
    ) : undefined
  }

export const stringLengthIsLessThan =
  (max: number) =>
  (val?: string): React.ReactElement | undefined => {
    return val !== undefined && val.length > max ? (
      <Trns
        source={'Must be less than ${max} characters in length'}
        expressions={{
          max: `${max}`,
        }}
      />
    ) : undefined
  }

export const stringIsLuhnValid = (
  val?: string,
): React.ReactElement | undefined => {
  let nCheck = 0
  let nDigit = 0
  let bEven = false
  const cleanVal = val?.replace(/\D/g, '')

  if (cleanVal && cleanVal.length > 0) {
    for (let n = cleanVal.length - 1; n >= 0; n--) {
      const cDigit = cleanVal.charAt(n)
      nDigit = parseInt(cDigit, 10)

      if (bEven) {
        if ((nDigit *= 2) > 9) nDigit -= 9
      }

      nCheck += nDigit
      bEven = !bEven
    }

    return nCheck % 10 !== 0 || cleanVal.length > 16 || cleanVal.length < 15 ? (
      <Trns source={'Please enter a valid card number'} />
    ) : undefined
  } else {
    return <Trns source={'Please enter a valid card number'} />
  }
}

export const cvcIsEmpty = (val?: string): React.ReactElement | undefined =>
  val === undefined || val.trim().length === 0 ? (
    <Trns source={'This field is required by your bank'} />
  ) : undefined

export const stringIsValidEmail =
  (message?: string) =>
  (val?: string): React.ReactElement | undefined => {
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i

    return val === undefined || !emailRegex.test(val) ? (
      <Trns
        source={
          message !== undefined ? message : 'Please enter a valid email address'
        }
      />
    ) : undefined
  }

export const stringIsNotURL =
  (message?: string) =>
  (val?: string): React.ReactElement | undefined => {
    const url = isUrl(val || '', { lenient: false })
    if (!url) {
      return undefined
    }

    return <Trns source={message || 'Invalid value'} />
  }
